import { FormSectionHeader } from "@/components";
import { Card, CardContent } from "@/components/ui";
import useReportSection from "./useReportSection";

const ReportSection = () => {
  const { onReportCardClick, reportCards, collectionReportCards } =
    useReportSection();

  return (
    <div className="bg-[linear-gradient(to_right_top,#2487C5,#0B4195)] text-white rounded-lg p-[20px] ">
      <FormSectionHeader className="text-[24px] font-[500]">
        Reports
      </FormSectionHeader>

      <>
        <FormSectionHeader className="text-[18px] font-[500]">
          Invoice Report
        </FormSectionHeader>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {reportCards?.map((data: any) => (
            <Card
              className="bg-[rgba(255,255,255,0.3)] text-white border-none cursor-pointer shadow-2xl"
              onClick={onReportCardClick(data?.link)}
            >
              <CardContent className="flex flex-row items-center gap-5">
                <div className="flex items-center rounded-full p-4 bg-white">
                  <img src={data.icon} className=" w-[50px]" />
                </div>
                <span className="text-[16px] lg:text-[20px] font-[500]">
                  {data?.title || ""}
                </span>
              </CardContent>
            </Card>
          ))}
        </div>
      </>
      <hr className="my-5" />
      <>
        <FormSectionHeader className="text-[18px] font-[500]">
          Collection Report
        </FormSectionHeader>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {collectionReportCards?.map((data: any) => (
            <Card
              className="bg-[rgba(255,255,255,0.3)] text-white border-none cursor-pointer shadow-2xl"
              onClick={onReportCardClick(data?.link)}
            >
              <CardContent className="flex flex-row items-center gap-5">
                <div className="flex items-center rounded-full p-4 bg-white">
                  <img src={data.icon} className=" w-[50px]" />
                </div>
                <span className="text-[16px] lg:text-[20px] font-[500]">
                  {data?.title || ""}
                </span>
              </CardContent>
            </Card>
          ))}
        </div>
      </>
    </div>
  );
};

export default ReportSection;
